import React, { useState } from 'react';
import './App.css';

interface ShortenResponse {
  shortCode: string;
  shortUrl: string;
}

function App() {
  const [url, setUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setShortUrl('');

    try {
      const response = await fetch('https://shortn.phillblaul.com/api/shorten', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        throw new Error('Failed to shorten URL');
      }

      const data: ShortenResponse = await response.json();
      setShortUrl(data.shortUrl);
      setUrl('');
    } catch (err) {
      setError('Failed to shorten URL. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shortUrl);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Shortn</h1>
        <p>Simple URL Shortener</p>
        
        <form onSubmit={handleSubmit} className="url-form">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter URL to shorten..."
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading || !url}>
            {loading ? 'Shortening...' : 'Shorten'}
          </button>
        </form>

        {error && (
          <div className="error">
            {error}
          </div>
        )}

        {shortUrl && (
          <div className="result">
            <h3>Shortened URL:</h3>
            <div className="short-url">
              <a href={shortUrl} target="_blank" rel="noopener noreferrer">
                {shortUrl}
              </a>
              <button onClick={copyToClipboard} className="copy-btn">
                Copy
              </button>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;